import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-500 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="w-full h-full"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}
        ></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-xl font-bold text-white">OOPBuy Spreadsheet.</span>
            </Link>
            <p className="text-white/60 text-sm leading-relaxed mb-4 max-w-xs">
              Der ultimative Guide für OOPBuy Spreadsheet in Deutschland. Sicher, schnell und transparent.
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Kategorien</h4>
            <ul className="space-y-2">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-white/60 text-sm hover:text-white transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Guides</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/artikel/oopbuy-spreadsheet-guide" className="text-white/60 text-sm hover:text-white transition-colors">
                  Kompletter Guide
                </Link>
              </li>
              <li>
                <Link to="/artikel/oopbuy-qc-guide" className="text-white/60 text-sm hover:text-white transition-colors">
                  QC Guide
                </Link>
              </li>
              <li>
                <Link to="/artikel/oopbuy-versand-guide" className="text-white/60 text-sm hover:text-white transition-colors">
                  Versand Guide
                </Link>
              </li>
              <li>
                <Link to="/artikel/oopbuy-verkaeufer-guide" className="text-white/60 text-sm hover:text-white transition-colors">
                  Verkäufer Guide
                </Link>
              </li>
              <li>
                <Link to="/artikel/oopbuy-spreadsheet-schuhe" className="text-white/60 text-sm hover:text-white transition-colors">
                  Schuhe Guide
                </Link>
              </li>
              <li>
                <Link to="/artikel/oopbuy-spreadsheet-hoodie" className="text-white/60 text-sm hover:text-white transition-colors">
                  Hoodie Guide
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Rechtliches</h4>
            <ul className="space-y-2">
              <li><a href="#" className="text-white/60 text-sm hover:text-white transition-colors">Datenschutz</a></li>
              <li><a href="#" className="text-white/60 text-sm hover:text-white transition-colors">Cookie-Richtlinie</a></li>
              <li><a href="#" className="text-white/60 text-sm hover:text-white transition-colors">Impressum</a></li>
              <li><a href="#" className="text-white/60 text-sm hover:text-white transition-colors">AGB</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 md:mt-14 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs">
            &copy; 2026 OOPBuy Spreadsheet. Alle Rechte vorbehalten.
          </p>
          <div className="flex items-center gap-3">
            {['ri-twitter-x-line', 'ri-instagram-line', 'ri-reddit-line', 'ri-telegram-line'].map((icon, idx) => (
              <div key={idx} className="w-8 h-8 rounded-lg border border-white/20 flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer">
                <i className={`${icon} text-white/60 text-sm`}></i>
              </div>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}